import { IOnlineCondolenceSummary } from "../../types/resources/OnlineCondolenceSummary";
import {useTranslation} from "react-i18next";
import OnlineCondolenceUtils from "../../utils/OnlineCondolenceUtils";
import ImageCard from '../ImageCard';
import Title from './Title';
import LifeDates from './LifeDates';
import {useSettingsContext} from '../../context/settings/useSettingsContext';
import ConditionalLink from '../ConditionalLink';

type TProps = {
    summary: IOnlineCondolenceSummary;
}

const OnlineCondolenceCard = ({ summary }: TProps) => {
    const { t } = useTranslation();
    const { publicUrl } = useSettingsContext();

    const fullName = OnlineCondolenceUtils.getFullName(summary);

    return (
        <ConditionalLink to={summary.pageUrl ? `/${summary.pageUrl}` : null}>
            <ImageCard
                imageSrc={summary.imageFileUrl ?? `${publicUrl}/placeholder-condolence.jpg`}
                placeholderSrc={`${publicUrl}/placeholder-condolence.jpg`}
                imageAlt={fullName}
            >
                <div className="cr-h-100 cr-p cr-center cr-flex cr-flex-col cr-gap">
                    <Title fullName={fullName}/>
                    <LifeDates dateOfBirth={summary.dateOfBirth} dateOfDeath={summary.dateOfDeath}/>
                    <div className="cr-upper cr-text-secondary cr-text-sm cr-p cr-mt-auto">
                        {t('express-condolences')}
                    </div>
                </div>
            </ImageCard>
        </ConditionalLink>
    );
}

export default OnlineCondolenceCard;
